import { useSettingsStore } from '../stores/settings';

function fire(pattern: number | number[]): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  const enabled = useSettingsStore.getState().settings.haptic_feedback;
  if (!enabled) return;
  try { navigator.vibrate(pattern); } catch { /* ignore */ }
}

export const haptics = {
  softSend: () => { /* no-op */ },
  firmSend: () => fire(50),
  firmReceive: () => fire([100, 50, 100]),
  softReceive: () => fire(20),
  ackTap: () => fire(30),
};
